import { Collection } from 'modules/core/lib/mobx-rest'

import StatsModel from 'modules/shift_management/store/api/models/Stats'

class Stats extends Collection<StatsModel> {
  get cacheKey(): string {
    return 'stats'
  }
  model() {
    return StatsModel
  }
}

const singleton: Stats = new Stats()

export default singleton
